import { useEffect, useState } from "react";
import instance from "../../Interceptor/api_instance";
import { useTranslation } from "react-i18next";
import { Spinner } from "../LoadingAnimations/LoadingAnimations";
import { convertToPST } from "../../Helper/FormatDatetimes";

const ViewReservations = () => {
  const { t } = useTranslation();
  const [reservations, setReservations] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await instance.get("assets/user-reservations/");
        if (response.status === 200) {
          setReservations(response.data);
        }
      } catch (error) {
        console.log(error);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <div className="graphics-card">
        <h4 className="global-h4 gray">
          {t("graphics-cont.reservations.header")}
        </h4>
        {error && <p className="error">{error}</p>}
        <div className="recent-activity">
          {isLoading ? (
            <Spinner />
          ) : reservations !== "" ? (
            reservations.map((reservation, index) => (
              <div key={index} className="activity-item">
                <div className="reservation-item-cont">
                  <div>
                    <span className="">Trailer: </span>
                    <span className="global-h5 gray">
                      {reservation.trailer.trailer_number}
                    </span>
                  </div>
                  {reservation.truck_asset && (
                    <div>
                      <span className="">{t("yard-tables.tabs.truck")}: </span>
                      <span className="global-h5 gray">
                        {reservation.truck_asset?.company}-
                        {reservation.truck_asset?.name}
                      </span>
                    </div>
                  )}
                  <div>
                    <span className="">{t("driversTable.columns.name")}: </span>
                    <span className="global-h5 gray">
                      {reservation.user.first_name} {reservation.user.last_name}
                    </span>
                  </div>
                  <div>
                    <span className="">{t("yard-tables.table-columns.datetime")}: </span>
                    <span className="global-h5 gray">
                      {convertToPST(reservation.due_datetime)}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : null}
        </div>
      </div>

    </>
  );
};

export default ViewReservations;